
import service from '../request/index'




// 手机验证码验证
export function codeCheck (data) {
  return service({
    url: '/api/open/center/confirmPhoneRand',
    method: 'GET',
    params:data
  })
}



// 设置新支付密码
export function changePassword (data) {
  return service({
    url: '/es/resource/my/verifyAccount/changePassword',
    method: 'POST',
    data
  })
}

// 换绑手机
export function changePhone (data) {
  return service({
    url: '/es/resource/my/verifyAccount/changePhone',
    method: 'POST',
    data
  })
}

// 获取滑动验证码的图片
export function getImgSwipe (data) {
  return service({
    url: '/api/login/getImgSwipe',
    method: 'get',
    params: data
  })
}

// 提交验证滑动验证码结果，返回0失败，1成功，2超过规定次数需要刷新
export function rstImgSwipe (data) {
  return service({
    url: '/api/login/rstImgSwipe',
    method: 'post',
    data
  })
}


// 发送手机验证码，增加滑动图片验证
export function sendPhoneAfterVerify (params,data) {
  return service({
    url: '/api/open/center/sendPhoneAfterVerify',
    method: 'put',
    params,
    data
  })
}


// 手机发送验证码
export function sendCode (data) {
  return service({
    url: '/api/open/center/sendPhone',
    method: 'put',
    params:data
  })
}


// 支付宝授权回调
export function oauth2 (data) {
  return service({
    url: '/es/resource/my/alipay/oauth2',
    method: 'get',
    params:data
  })
}


// 换绑支付宝
export function replaceAlipay (data) {
  return service({
    url: '/es/resource/my/replace/alipay',
    method: 'get',
    params:data
  })
}
